import { render, staticRenderFns } from "./sales-promo.vue?vue&type=template&id=39710b30"
import script from "./sales-promo.vue?vue&type=script&lang=js"
export * from "./sales-promo.vue?vue&type=script&lang=js"
import style0 from "./sales-promo.vue?vue&type=style&index=0&id=39710b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports